export const TranlsationKey = 'authentication';
